import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import useEventListener from "../../../hooks/event-handler";

export interface IListTarget {
  id: number;
  name: string;
}
export default function UseCompleteCompanyIndustrieTargetReseller() {
  const history = useHistory();
  const [companyTarget, setcompanyTarget] = useState<Array<IListTarget>>([]);
  const [companyTargetSecound, setcompanyTargetSecond] = useState<
    Array<IListTarget>
  >([]);
  const [lastCompanyTarget, setLastcompanyTargetSecond] = useState<
    Array<IListTarget>
  >([]);
  const [dataCompleted, setDataCompleted] = useState(
    JSON.parse(sessionStorage.getItem("completed_account") || "{}")
  );
  const [loader, setLoaderState] = useState<boolean>(false);
  const [companyTargetSelected, setCompanyTargetSelected] = useState<
    Array<IListTarget>
  >(JSON.parse(sessionStorage.getItem("target_company") || "[]"));
  const [errorData, setErrorData] = useState<boolean>(false);

  const navigateCompleteDescription = () => {
    if (companyTargetSelected.length > 0) {
      sessionStorage.setItem(
        "target_company",
        JSON.stringify(companyTargetSelected)
      );
      history.push("/complete-company-description-reseller");
    } else {
      setErrorData(true);
    }
  };

  useEffect(() => {
    async function getTargetCompany() {
      let dataTargetCompany = dataCompleted?.targetedIndustry;
      let divider = Math.floor(dataTargetCompany.length / 3);
      let firstColumn = dataTargetCompany?.slice(0, divider);
      let secondColumn = dataTargetCompany?.slice(divider, divider * 2);
      let lastComumn = dataTargetCompany?.slice(divider * 2);
      setcompanyTarget(firstColumn);
      setcompanyTargetSecond(secondColumn);
      setLastcompanyTargetSecond(lastComumn);
      setLoaderState(false);
    }
    getTargetCompany();
    return () => {};
  }, []);

  const addTargetCompany = (dataMake: IListTarget) => {
    let found = companyTargetSelected?.find(
      (el: IListTarget) => el.id == dataMake.id
    );
    if (!found) {
      setCompanyTargetSelected([...companyTargetSelected, dataMake]);
    } else {
      setCompanyTargetSelected(
        companyTargetSelected?.filter(
          (elem: IListTarget) => elem.id != dataMake.id
        )
      );
    }
  };

  useEffect(() => {
    setErrorData(false);
    return () => {};
  }, [companyTargetSelected]);

  const goBack = () => {
    history.goBack();
  };

  const keyEnter = ({ key }: any) => {
    if (key == "Enter") {
      navigateCompleteDescription();
    } else return;
  };

  useEventListener("keydown", keyEnter);

  return {
    navigateCompleteDescription,
    addTargetCompany,
    companyTarget,
    companyTargetSecound,
    lastCompanyTarget,
    loader,
    companyTargetSelected,
    goBack,
    errorData,
  };
}
